import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { createRef, Fragment } from 'react';
import Autosuggest from 'react-autosuggest';
import { fromJS, is, List } from 'immutable';
import { debounce } from 'lodash-es';
var initialState = {
  editing: false,
  searchField: null,
  searchValue: '',
  refocus: false,
  result: null
};
export var Typeahead = /*#__PURE__*/function (_React$Component) {
  _inherits(Typeahead, _React$Component);

  var _super = _createSuper(Typeahead);

  function Typeahead(props) {
    var _this;

    _classCallCheck(this, Typeahead);

    _this = _super.call(this, props);

    _this.edit = function (event) {
      if (event.type === 'click' || event.type === 'keydown' && (event.keyCode === 13 || event.keyCode === 32)) {
        event.preventDefault();
        event.stopPropagation();

        if (!_this.props.disabled) {
          _this.setState({
            editing: true
          });
        }
      }
    };

    _this.remove = function (i) {
      return function (event) {
        if (event) {
          event.preventDefault();
          event.stopPropagation();
        }

        if (!_this.props.disabled) {
          _this.props.onChange(_this.props.multiple ? _this.props.value["delete"](i) : null);
        }
      };
    };

    _this.onHighlight = function (_ref) {
      var suggestion = _ref.suggestion;

      if (typeof _this.props.onHighlight === 'function') {
        _this.props.onHighlight(suggestion);
      }
    };

    _this.onSuggestionsResponse = function (searchedValue) {
      return function (_ref2) {
        var suggestions = _ref2.suggestions,
            error = _ref2.error,
            nextPageToken = _ref2.nextPageToken;

        if (searchedValue === _this.state.searchValue) {
          // when multiple mode is enabled we don't want to allow the same
          // suggestion to be selected twice, we compare existing selections to
          // suggestions using the getSuggestionValue function that returns a string
          // this is necessary because one of the objects may have additional fields
          // but should be treated as equal to an object without those fields.
          var mappedValues = _this.props.multiple && _this.props.value.map(_this.props.getSuggestionValue);

          var filtered = suggestions.map(function (suggestion) {
            return fromJS(suggestion);
          }).filter(function (suggestion) {
            return !_this.props.multiple || !mappedValues.includes(_this.props.getSuggestionValue(suggestion));
          });
          var customSuggestion = _this.props.custom && // if the current searchValue matches an existing suggestion we do not
          // include it as a custom option
          filtered.filter(function (suggestion) {
            return _this.props.getSuggestionValue(suggestion) === _this.state.searchValue;
          }).length === 0 && fromJS(_this.props.custom(_this.state.searchValue));

          _this.setState({
            result: {
              error: error,
              nextPageToken: nextPageToken,
              suggestions: customSuggestion ? [].concat(_toConsumableArray(filtered), [customSuggestion]) : filtered,
              customSuggestion: customSuggestion
            }
          });
        }
      };
    };

    _this.onSuggestionsFetchRequested = function (_ref3) {
      var searchValue = _ref3.value,
          reason = _ref3.reason;

      if (reason === 'escape-pressed' && _this.state.searchValue === '') {
        _this.setState(initialState);
      } else if (reason !== 'suggestion-selected') {
        _this.setState({
          editing: true,
          searchValue: searchValue
        });
      } else if (!_this.props.multiple) {
        _this.setState({
          refocus: true
        });
      }
    };

    _this.onSuggestionsClearRequested = function () {
      _this.setState(initialState);
    };

    _this.setSearchField = function (searchField) {
      return function () {
        _this.setState({
          searchField: searchField
        });
      };
    };

    _this.onSuggestionSelected = function (event, _ref4) {
      var method = _ref4.method,
          suggestion = _ref4.suggestion;

      // Prevent form submission if enter key is used to select suggestion.
      if (method === 'enter') {
        event.preventDefault();
      }

      _this.setState(_this.props.multiple ? {
        searchValue: ''
      } : initialState);

      _this.props.onChange(_this.props.multiple ? _this.props.value.push(suggestion) : suggestion);
    };

    _this.state = initialState;
    _this.autosuggest = createRef();
    _this.focusRef = createRef();
    _this.search = debounce(function () {
      var _this$props;

      (_this$props = _this.props).search.apply(_this$props, arguments);
    }, 150);
    _this.renderInputComponent = renderInputComponent.bind(_assertThisInitialized(_this));
    _this.renderSuggestion = renderSuggestion.bind(_assertThisInitialized(_this));
    _this.renderSuggestionsContainer = renderSuggestionsContainer.bind(_assertThisInitialized(_this));
    _this.renderSelections = renderSelections.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(Typeahead, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState, snapshot) {
      var searchLongEnough = !this.props.minSearchLength || this.state.searchValue.length >= this.props.minSearchLength;
      var searchChanged = this.state.searchField !== prevState.searchField || this.state.searchValue !== prevState.searchValue;
      var valueChanged = !is(this.props.value, prevProps.value);

      if (this.state.editing) {
        if (searchChanged || valueChanged || !prevState.editing) {
          // Always clear the result even if the search value is not long enough,
          // in that case a message should be displayed in place of results.
          this.setState({
            result: null
          });

          if (searchLongEnough) {
            this.search(this.state.searchField, this.state.searchValue, this.onSuggestionsResponse(this.state.searchValue));
          }
        } // If the previous state was not editing then we make sure the Autosuggest
        // input element is focused because it may not be visible before this.


        if (!prevState.editing) {
          this.autosuggest.current.input.focus();
        }
      }

      if (this.state.refocus && !prevState.refocus) {
        if (this.focusRef.current) {
          this.focusRef.current.focus();
        }

        this.setState({
          refocus: false
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props$component = this.props.components.SelectionsContainer,
          SelectionsContainer = _this$props$component === void 0 ? SelectionsContainerDefault : _this$props$component;
      return /*#__PURE__*/React.createElement(SelectionsContainer, {
        disabled: this.props.disabled,
        multiple: this.props.multiple,
        value: this.props.value,
        selections: this.props.multiple || !this.state.editing ? this.renderSelections() : null,
        input: (this.props.multiple || this.state.editing) && /*#__PURE__*/React.createElement(Autosuggest, {
          alwaysRenderSuggestions: true,
          getSuggestionValue: this.props.getSuggestionValue,
          highlightFirstSuggestion: !this.props.noAutoHighlight,
          inputProps: {
            value: this.state.searchValue,
            onBlur: this.props.onBlur,
            onChange: onChangeNOOP,
            onFocus: this.props.onFocus,
            selection: this.props.value
          },
          onSuggestionHighlighted: this.onHighlight,
          onSuggestionSelected: this.onSuggestionSelected,
          onSuggestionsClearRequested: this.onSuggestionsClearRequested,
          onSuggestionsFetchRequested: this.onSuggestionsFetchRequested,
          ref: this.autosuggest,
          renderInputComponent: this.renderInputComponent,
          renderSuggestion: this.renderSuggestion,
          renderSuggestionsContainer: this.renderSuggestionsContainer,
          suggestions: this.state.result ? this.state.result.suggestions : []
        })
      });
    }
  }]);

  return Typeahead;
}(React.Component); // RENDER HELPERS below need to bind to the Typeahead instance because they use
// methods / props / state. They could be defined in the class instead but since
// they do not alter state at all they were moved here to make that class
// hopefully easier to comprehend. They are intended to be passed to the
// corresponding (by name) props of the Autosuggest component.
// https://github.com/moroshko/react-autosuggest#render-suggestions-container-prop

function renderSuggestionsContainer(_ref5) {
  var containerProps = _ref5.containerProps,
      children = _ref5.children;
  var _this$props2 = this.props,
      _this$props2$componen = _this$props2.components,
      _this$props2$componen2 = _this$props2$componen.Status,
      Status = _this$props2$componen2 === void 0 ? StatusDefault : _this$props2$componen2,
      _this$props2$componen3 = _this$props2$componen.SuggestionsContainer,
      SuggestionsContainer = _this$props2$componen3 === void 0 ? SuggestionsContainerDefault : _this$props2$componen3,
      custom = _this$props2.custom,
      getStatusProps = _this$props2.getStatusProps,
      minSearchLength = _this$props2.minSearchLength,
      setSearchField = this.setSearchField,
      state = this.state;
  return /*#__PURE__*/React.createElement(SuggestionsContainer, {
    containerProps: containerProps,
    open: state.editing
  }, /*#__PURE__*/React.createElement(Status, getStatusProps({
    searchField: state.searchField,
    setSearchField: setSearchField,
    error: state.result && state.result.error,
    value: state.searchValue,
    empty: state.result && state.result.suggestions.length === 0,
    more: state.result && !!state.result.nextPageToken,
    "short": minSearchLength && state.searchValue.length < minSearchLength,
    pending: !state.result,
    custom: !!custom
  })), children);
} // https://github.com/moroshko/react-autosuggest#render-suggestion-prop


function renderSuggestion(suggestion, _ref6) {
  var isHighlighted = _ref6.isHighlighted;
  var _this$props3 = this.props,
      _this$props3$componen = _this$props3.components.Suggestion,
      Suggestion = _this$props3$componen === void 0 ? SuggestionDefault : _this$props3$componen,
      getSuggestionValue = _this$props3.getSuggestionValue;
  var custom = this.state.result && this.state.result.customSuggestion === suggestion;
  return /*#__PURE__*/React.createElement(Suggestion, {
    active: isHighlighted,
    custom: custom,
    suggestion: suggestion,
    suggestionValue: getSuggestionValue(suggestion)
  });
} // https://github.com/moroshko/react-autosuggest#renderinputcomponent-optional


function renderInputComponent(inputProps) {
  var _this$props$component2 = this.props.components.Input,
      Input = _this$props$component2 === void 0 ? TypeaheadInputDefault : _this$props$component2;
  return /*#__PURE__*/React.createElement(Input, {
    inputProps: inputProps
  });
} // Another render helper like the ones above but not actually for Autosuggest,
// just meant to cleanup the render function of Typeahead.


function renderSelections() {
  var edit = this.edit,
      focusRef = this.focusRef,
      _this$props4 = this.props,
      _this$props4$componen = _this$props4.components.Selection,
      Selection = _this$props4$componen === void 0 ? SelectionDefault : _this$props4$componen,
      disabled = _this$props4.disabled,
      getSuggestionValue = _this$props4.getSuggestionValue,
      multiple = _this$props4.multiple,
      value = _this$props4.value,
      remove = this.remove;
  return (multiple ? value : List.of(value)).map(function (selection, i) {
    var suggestionValue = getSuggestionValue(selection);
    return /*#__PURE__*/React.createElement(Selection, {
      key: suggestionValue,
      disabled: disabled,
      edit: !multiple ? edit : null,
      focusRef: !multiple ? focusRef : null,
      remove: multiple ? remove(i) : remove(),
      selection: selection,
      suggestionValue: suggestionValue
    });
  });
} // DEFAULT COMPONENTS below render minimally useful content. They can and should
// be overridden by the components prop passed to Typeahead. If they need props
// or state from the Typeahead instance there will be a render* helper above
// that will bind to it.


var StatusDefault = function StatusDefault(props) {
  return /*#__PURE__*/React.createElement("div", null, props.info && /*#__PURE__*/React.createElement("div", null, props.info, /*#__PURE__*/React.createElement("button", {
    onClick: props.clearFilterField
  }, "\xD7")), props.warning && /*#__PURE__*/React.createElement("div", null, props.warning), props.filterFieldOptions && props.filterFieldOptions.map(function (_ref7, i) {
    var label = _ref7.label,
        onClick = _ref7.onClick;
    return /*#__PURE__*/React.createElement("button", {
      onClick: onClick,
      key: i
    }, label);
  }));
};

var SuggestionsContainerDefault = function SuggestionsContainerDefault(_ref8) {
  var children = _ref8.children,
      containerProps = _ref8.containerProps,
      open = _ref8.open;
  return /*#__PURE__*/React.createElement("div", Object.assign({}, containerProps, {
    style: open ? {} : {
      display: 'none'
    }
  }), children);
};

var SelectionsContainerDefault = function SelectionsContainerDefault(_ref9) {
  var selections = _ref9.selections,
      input = _ref9.input;
  return /*#__PURE__*/React.createElement(Fragment, null, selections, input);
};

var SelectionDefault = function SelectionDefault(_ref10) {
  var selection = _ref10.selection,
      remove = _ref10.remove,
      edit = _ref10.edit,
      suggestionValue = _ref10.suggestionValue;
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("span", null, suggestionValue || /*#__PURE__*/React.createElement("em", null, "None")), edit && /*#__PURE__*/React.createElement("button", {
    type: "button",
    onClick: edit
  }, suggestionValue ? 'edit' : 'add'), selection && /*#__PURE__*/React.createElement("button", {
    type: "button",
    onClick: remove
  }, "remove"));
};

var SuggestionDefault = function SuggestionDefault(_ref11) {
  var active = _ref11.active,
      suggestionValue = _ref11.suggestionValue;
  return /*#__PURE__*/React.createElement("div", null, active ? /*#__PURE__*/React.createElement("strong", null, suggestionValue) : suggestionValue);
};

var TypeaheadInputDefault = function TypeaheadInputDefault(_ref12) {
  var inputProps = _ref12.inputProps;
  return /*#__PURE__*/React.createElement("input", inputProps);
}; // This is passed to the Autosuggest input but we do not want to update that
// value when pressing up/down and we do not want to set that input when a
// suggestion is clicked so we are making this a noop. Instead we update the
// searchValue state when `onSuggestionsFetchRequested` is called.


var onChangeNOOP = function onChangeNOOP(event, _ref13) {
  var newValue = _ref13.newValue,
      method = _ref13.method;
};